'use client';

import { c as _c } from "react/compiler-runtime";
import { Memo } from '@legendapp/state/react';
import type { Observable } from '@legendapp/state';
import type { TestimonialCardProps } from '@/components/cards/TestimonialCard';
import { TestimonialCard } from '@/components/cards/TestimonialCard';
import type { CardState } from '@/hooks/useAnimatedCardStackState';
import { cn } from '@/lib/cn';
import { useTestimonialsBlockState } from './TestimonialsBlockProvider';
export interface TestimonialsBlockCardProps extends Omit<TestimonialCardProps, 'testimonial' | 'shade' | 'color'> {
  card$: Observable<CardState>;
}
export function TestimonialsBlockCard(t0) {
  const $ = _c(9);
  let card$;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      card$,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = card$;
    $[2] = className;
    $[3] = props;
  } else {
    card$ = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    cardState$
  } = useTestimonialsBlockState();
  let t1;
  if ($[4] !== card$ || $[5] !== cardState$ || $[6] !== className || $[7] !== props) {
    t1 = <Memo>{() => <TestimonialCard testimonial={cardState$.getItemForCard(card$)} color="secondary" shade={card$.gradientShade.get()} className={cn("row-span-full col-span-full self-center select-none", className, {
        "z-3": card$.index.get() === 0,
        "z-2": card$.index.get() === 1,
        "z-1": card$.index.get() === 2
      })} $animate={() => card$.animation.get()} $drag={() => card$.positionIndex.get() === 0 ? "x" : false} onDragStart={() => {
        cardState$.handleDragStart(card$);
      }} onDrag={(_event, info) => {
        cardState$.handleDrag(card$, info);
      }} onDragEnd={(_event_0, info_0) => {
        cardState$.handleDragEnd(card$, info_0);
      }} onAnimationComplete={() => {
        cardState$.handleAnimationComplete(card$);
      }} {...props} />}</Memo>;
    $[4] = card$;
    $[5] = cardState$;
    $[6] = className;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}